/* ============================================================
   UPC France — interactions
   - 3D flip cards (hover holo/glare + tilt)
   - global product quick-view modal (flip + zoom + thumbs)
   - hero deck fan-out (GSAP ScrollTrigger, pinned)
   - grail (scroll rotate recto/verso, rays, sparks, price count-up)
   - scroll progress bar + reveal-on-scroll
   No Lenis (native scroll) for Shopify editor stability.
   ============================================================ */
(function () {
  'use strict';

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* verrou de scroll sans saut : on compense la largeur de la scrollbar pour
     que le contenu ne glisse pas quand on masque l'overflow du body */
  var _scrollLocks = 0;
  function lockScroll() {
    if (_scrollLocks++ > 0) return;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.dataset.upcPadPrev = document.body.style.paddingRight || '';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (_scrollLocks > 0) _scrollLocks--;
    if (_scrollLocks > 0) return;
    document.body.style.overflow = '';
    document.body.style.paddingRight = document.body.dataset.upcPadPrev || '';
    delete document.body.dataset.upcPadPrev;
  }

  /* ============================================================
     1. Hover tilt + holo position on any .upc-card
     ============================================================ */
  function initCardHover() {
    $all('.upc-card').forEach(function (card) {
      if (card.dataset.upcHover) return;
      card.dataset.upcHover = '1';
      var inner = card.querySelector('.upc-card-inner');
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        card.style.setProperty('--mx', (px * 100) + '%');
        card.style.setProperty('--my', (py * 100) + '%');
        if (inner && !card.dataset.upcNoTilt) {
          inner.style.transform = 'rotateY(' + (px - 0.5) * 30 + 'deg) rotateX(' + (0.5 - py) * 24 + 'deg)';
        }
      });
      card.addEventListener('mouseleave', function () {
        if (inner && !card.dataset.upcNoTilt) inner.style.transform = '';
      });
    });
  }

  /* ============================================================
     2. Global quick-view modal
     ============================================================ */
  var modal = {
    el: null, inner: null, card: null,
    flipped: false, tiltX: 0, tiltY: 0, zoom: 1, panX: 0, panY: 0, hasBack: false
  };

  function eur(value) {
    // value: already-formatted string passed from Liquid
    return value;
  }

  function applyMcard() {
    modal.card.style.transform = 'translate(' + modal.panX + 'px,' + modal.panY + 'px) scale(' + modal.zoom + ')';
    modal.card.classList.toggle('zoomed', modal.zoom > 1);
    var base = modal.flipped ? 180 : 0;
    modal.inner.style.transform = 'rotateX(' + modal.tiltX + 'deg) rotateY(' + (base + modal.tiltY) + 'deg)';
  }
  function setFlip(v) {
    if (!modal.hasBack) v = false;
    modal.flipped = v;
    var thF = $('#upc-thF'), thB = $('#upc-thB');
    if (thF) thF.classList.toggle('act', !v);
    if (thB) thB.classList.toggle('act', v);
    applyMcard();
  }
  function setZoom(z) {
    modal.zoom = Math.min(3, Math.max(1, z));
    if (modal.zoom === 1) {
      modal.panX = modal.panY = 0;
    } else if (modal.card) {
      // re-borne le déplacement selon le NOUVEAU zoom (sinon en dézoomant la
      // carte "part" dans un coin car le pan reste calé sur l'ancien zoom).
      var mx = (modal.card.offsetWidth * (modal.zoom - 1)) / 2;
      var my = (modal.card.offsetHeight * (modal.zoom - 1)) / 2;
      modal.panX = Math.max(-mx, Math.min(mx, modal.panX));
      modal.panY = Math.max(-my, Math.min(my, modal.panY));
    }
    modal.tiltX = modal.tiltY = 0;
    applyMcard();
  }

  function openModalFromEl(el) {
    if (!modal.el) return;
    var d = el.dataset;
    var front = d.upcFront || '';
    var back = d.upcBack || '';
    modal.hasBack = !!back;
    $('#upc-mFront').src = front; $('#upc-mFront').alt = d.upcName || '';
    $('#upc-mBack').src = back || front;
    $('#upc-thFimg').src = front;
    $('#upc-thBimg').src = back || front;
    var mGradeEl = $('#upc-mGrade');
    if (mGradeEl) { mGradeEl.textContent = ''; mGradeEl.style.display = 'none'; }
    $('#upc-mName').textContent = d.upcName || '';
    $('#upc-mSet').textContent = d.upcSet || '';
    $('#upc-mPrice').textContent = eur(d.upcPrice || '');
    var specsEl = $('#upc-mSpecs');
    if (specsEl) {
      // Gradée (société + note) -> "Note : PSA 10" et pas d'état. Sinon -> État.
      var graded = d.upcCompany && d.upcNote;
      var specs = [];
      if (graded) {
        specs.push(['Note', (d.upcCompany + ' ' + d.upcNote).trim()]);
      } else {
        specs.push(['État', d.upcCondition]);
      }
      specs.push(['Rareté', d.upcRarity]);
      specs.push(['Langue', d.upcLanguage]);
      specs.push(['Disponibilité', d.upcStock]);
      specs = specs.filter(function (s) { return s[1] && String(s[1]).trim(); });
      specsEl.innerHTML = specs.map(function (s) {
        return '<div class="upc-mspec"><div class="k">' + s[0] + '</div><div class="v">' + String(s[1]) + '</div></div>';
      }).join('');
    }
    var view = $('#upc-mView');
    if (view) { view.href = d.upcUrl || '#'; }
    // Quantité + stock. Etat initial = inventaire de la carte, puis stock LIVE
    // (/cart.js) qui déduit ce que tu as déjà au panier -> addable réel.
    var note = $('[data-mstock-note]');
    if (note) { note.textContent = ''; note.classList.remove('is-warn'); }
    var qtyInput0 = $('#upc-mQty'); if (qtyInput0) qtyInput0.value = 1;
    modal.variant = d.upcVariant || '';
    modal.invMax = parseInt(d.upcMax, 10); if (isNaN(modal.invMax)) modal.invMax = 99;
    modal.token = (modal.token || 0) + 1;
    applyModalStock(String(d.upcAvailable || '') === 'true' ? modal.invMax : 0);
    fetchModalStock();
    var thBwrap = $('#upc-thBwrap'), flipBtn = $('#upc-flipBtn');
    if (thBwrap) thBwrap.style.display = modal.hasBack ? '' : 'none';
    if (flipBtn) flipBtn.style.display = modal.hasBack ? '' : 'none';

    modal.flipped = false; modal.tiltX = 0; modal.tiltY = 0; modal.zoom = 1; modal.panX = 0; modal.panY = 0;
    setFlip(false);
    modal.el.classList.add('open');
    modal.el.setAttribute('aria-hidden', 'false');
    lockScroll();
  }
  function closeModal() {
    if (!modal.el) return;
    if (!modal.el.classList.contains('open')) return;
    modal.el.classList.remove('open');
    modal.el.setAttribute('aria-hidden', 'true');
    modal.token = (modal.token || 0) + 1; // invalide tout fetch en cours
    unlockScroll();
  }

  // Applique un stock addable (max effectif) au modal : quantité, boutons, "Ajouter".
  // eff <= 0 -> quantité 0, +/- désactivés, bouton "Ajouter" grisé (comme la PDP).
  function applyModalStock(eff) {
    modal.max = (eff == null || isNaN(eff)) ? 99 : eff;
    var addBtn = $('#upc-mAdd'), qtyInput = $('#upc-mQty');
    var inStock = modal.max > 0 && !!modal.variant;
    if (qtyInput) {
      qtyInput.setAttribute('max', modal.max);
      var cur = parseInt(qtyInput.value, 10);
      if (!inStock) qtyInput.value = 0;
      else if (isNaN(cur) || cur < 1) qtyInput.value = 1;
      else if (cur > modal.max) qtyInput.value = modal.max;
    }
    if (addBtn) {
      var lbl = $('[data-add-label]', addBtn);
      addBtn.classList.toggle('upc-madd--out', !inStock);
      addBtn.setAttribute('aria-disabled', inStock ? 'false' : 'true');
      if (inStock) addBtn.removeAttribute('data-tip');
      else addBtn.setAttribute('data-tip', "Nous n'avons plus ce produit en stock");
      if (lbl) lbl.textContent = inStock ? 'Ajouter au panier' : 'Épuisé';
    }
    if (modal.updateQty) modal.updateQty();
  }

  // Stock LIVE fiable : /cart.js donne la quantité de cette variante déjà au panier.
  // addable = inventaire (data-upc-max de la carte) - déjà au panier.
  function fetchModalStock() {
    if (!modal.variant) return;
    var t = modal.token;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (modal.token !== t || !modal.el || !modal.el.classList.contains('open')) return;
        var inCart = 0;
        (cart.items || []).forEach(function (it) { if (String(it.variant_id) === String(modal.variant)) inCart += it.quantity; });
        var inv = modal.invMax;
        var eff = (inv == null || isNaN(inv) || inv >= 99) ? 99 : Math.max(0, inv - inCart);
        applyModalStock(eff);
      })
      .catch(function () {});
  }

  function addToCart() {
    var addBtn = $('#upc-mAdd');
    if (!addBtn || addBtn.classList.contains('upc-madd--out') || addBtn.dataset.busy === '1' || !modal.variant) return;
    var lbl = $('[data-add-label]', addBtn);
    var note = $('[data-mstock-note]');
    var qInput = $('#upc-mQty');

    // quantité demandée -> plafonnée au stock dispo (si suivi) + avertissement
    var qty = 1;
    if (qInput) { qty = parseInt(qInput.value, 10); if (isNaN(qty) || qty < 1) qty = 1; }
    if (qty > modal.max) {
      qty = modal.max;
      if (qInput) qInput.value = qty;
      if (note) {
        note.textContent = 'Il ne reste que ' + modal.max + ' exemplaire' + (modal.max > 1 ? 's' : '') + ' en stock — quantité ajustée au maximum disponible.';
        note.classList.add('is-warn');
      }
    }
    if (qty < 1) return; // rien à ajouter

    var prev = lbl ? lbl.textContent : '';
    addBtn.dataset.busy = '1';
    if (lbl) lbl.textContent = 'Ajout…';

    // Requête identique à product-form.js (Dawn) : FormData + Accept application/javascript
    // + sections via getSectionsToRender -> renderContents rend le vrai HTML du tiroir.
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var addUrl = (window.routes && window.routes.cart_add_url) || root + 'cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    var formData = new FormData();
    formData.append('id', modal.variant);
    formData.append('quantity', qty);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          // stock insuffisant (ex. déjà dans le panier) -> message clair
          if (note) { note.textContent = response.description || 'Stock insuffisant pour cette quantité.'; note.classList.add('is-warn'); }
          throw new Error('stock');
        }
        if (cart && typeof cart.renderContents === 'function') {
          // IMPORTANT : Dawn ne retire `is-empty` que via product-form ; sans ça,
          // le tiroir croit être vide -> trapFocus(null) plante et casse le style.
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response); // met à jour + ouvre le tiroir
          if (lbl) lbl.textContent = prev || 'Ajouter au panier';
          addBtn.dataset.busy = '0';
          // le modal reste OUVERT ; on prévient les listeners (PDP + ce modal)
          // pour resynchroniser le stock addable (l'article est maintenant au panier).
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upc-modal-add', cartData: response });
          }
          fetchModalStock();
        } else {
          window.location = cartUrl;
        }
      })
      .catch(function () {
        if (lbl) lbl.textContent = prev || 'Ajouter au panier';
        addBtn.dataset.busy = '0';
      });
  }

  // Page produit : plafonne la quantité tapée au stock dispo (le bouton + est déjà
  // limité par l'attribut max via stepUp). Délégué sur document -> survit aux
  // re-rendus lors du changement de variante. Exclut le panier.
  function initPdpQty() {
    function handle(e) {
      var input = e.target;
      if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
      if (input.closest('cart-items, cart-drawer-items, #CartDrawer')) return; // pas le panier
      var maxAttr = input.getAttribute('max');
      if (!maxAttr) return;
      var max = parseInt(maxAttr, 10);
      if (isNaN(max) || max < 1) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v)) return;
      var qi = input.closest('quantity-input');
      var note = qi && qi.parentNode ? qi.parentNode.querySelector('[data-upc-pdp-stock]') : null;
      if (v > max) {
        input.value = max;
        if (!note && qi && qi.parentNode) {
          note = document.createElement('p');
          note.className = 'upc-pdp-stock-note';
          note.setAttribute('data-upc-pdp-stock', '');
          note.setAttribute('aria-live', 'polite');
          qi.parentNode.insertBefore(note, qi.nextSibling);
        }
        if (note) note.textContent = 'Il ne reste que ' + max + ' exemplaire' + (max > 1 ? 's' : '') + ' en stock — quantité ajustée au maximum disponible.';
      } else if (note) {
        note.textContent = '';
      }
    }
    document.addEventListener('input', handle, true);
    document.addEventListener('change', handle, true);

    // Bloque RÉELLEMENT le clic sur + (au max) et − (au min) : Dawn ne fait que
    // griser visuellement, le clic incrémentait quand même. Capture -> on stoppe
    // avant le handler Dawn. On garde le curseur "interdit".
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.quantity__button') : null;
      if (!btn) return;
      var qi = btn.closest('quantity-input');
      if (!qi || qi.closest('cart-items, cart-drawer-items, #CartDrawer')) return;
      var input = qi.querySelector('.quantity__input');
      if (!input) return;
      var v = parseInt(input.value, 10);
      var name = btn.getAttribute('name');
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? parseInt(maxAttr, 10) : null;
      var min = input.getAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 1;
      if (name === 'plus' && max != null && !isNaN(max) && !isNaN(v) && v >= max) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var qip = qi.parentNode;
        var note = qip ? qip.querySelector('[data-upc-pdp-stock]') : null;
        if (!note && qip) {
          note = document.createElement('p');
          note.className = 'upc-pdp-stock-note';
          note.setAttribute('data-upc-pdp-stock', '');
          note.setAttribute('aria-live', 'polite');
          qip.insertBefore(note, qi.nextSibling);
        }
        if (note) note.textContent = 'Stock maximum atteint : ' + max + ' exemplaire' + (max > 1 ? 's' : '') + ' disponible' + (max > 1 ? 's' : '') + '.';
      } else if (name === 'minus' && !isNaN(v) && v <= min) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  // Re-synchronise dynamiquement le stock addable de la page produit à CHAQUE
  // changement de panier (ajout OU suppression, y compris depuis le tiroir).
  // On re-render la section produit côté serveur -> on récupère le vrai stock
  // et la vraie quantité déjà au panier, puis on met à jour le sélecteur.
  function initStockSync() {
    // Applique l'état "stock" à partir des attributs courants : max effectif =
    // stock (data-max) - quantité déjà au panier (data-cart-quantity). Si 0 ->
    // quantité à 0, boutons +/- désactivés ET "Ajouter au panier" grisé/désactivé.
    function applyStockState() {
      var host = document.querySelector('quantity-input');
      var input = host ? host.querySelector('.quantity__input') : null;
      if (!host || !input) return;
      var submit = document.querySelector('.product-form__submit');
      var dmaxAttr = input.getAttribute('data-max');
      // pas de suivi de stock -> aucune limite, on laisse Dawn gérer
      if (dmaxAttr == null || dmaxAttr === '') { if (submit) submit.classList.remove('upc-nostock'); return; }
      var dmax = parseInt(dmaxAttr, 10);
      var cartQ = parseInt(input.getAttribute('data-cart-quantity') || '0', 10) || 0;
      var eff = dmax - cartQ;
      if (isNaN(eff)) return;
      if (eff < 0) eff = 0;
      input.setAttribute('max', eff);
      var plus = host.querySelector('.quantity__button[name="plus"]');
      var minus = host.querySelector('.quantity__button[name="minus"]');
      if (eff <= 0) {
        input.value = 0;
        if (plus) plus.classList.add('disabled');
        if (minus) minus.classList.add('disabled');
        if (submit) { submit.setAttribute('disabled', ''); submit.setAttribute('aria-disabled', 'true'); submit.classList.add('upc-nostock'); }
      } else {
        if (isNaN(parseInt(input.value, 10)) || parseInt(input.value, 10) < 1) input.value = 1;
        if (parseInt(input.value, 10) > eff) input.value = eff;
        if (submit) { submit.removeAttribute('disabled'); submit.removeAttribute('aria-disabled'); submit.classList.remove('upc-nostock'); }
        if (typeof host.validateQtyRules === 'function') host.validateQtyRules();
      }
    }

    // Re-render la section produit côté serveur -> stock + quantité au panier frais,
    // puis applique l'état. Déclenché à chaque changement de panier + retour d'onglet.
    function refresh() {
      var host = document.querySelector('quantity-input');
      var input = host ? host.querySelector('.quantity__input') : null;
      if (!host || !input) return;
      var pi = document.querySelector('product-info');
      var url = host.getAttribute('data-url') || (pi && pi.getAttribute('data-url'));
      var section = host.getAttribute('data-section') || (pi && pi.getAttribute('data-section'));
      if (!url || !section) { applyStockState(); return; }
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + section)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.quantity__input');
          if (fresh) {
            ['data-cart-quantity', 'data-min', 'data-max', 'min', 'step'].forEach(function (a) {
              if (fresh.hasAttribute(a)) input.setAttribute(a, fresh.getAttribute(a));
              else input.removeAttribute(a);
            });
          }
          applyStockState();
        })
        .catch(function () {});
    }

    applyStockState();
    setTimeout(applyStockState, 400); // repasse après l'init async de Dawn
    function onCart() {
      refresh();
      if (modal.el && modal.el.classList.contains('open')) fetchModalStock();
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCart);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) onCart(); });
  }

  function initModal() {
    modal.el = $('#upc-modal');
    if (!modal.el) return;
    modal.inner = $('#upc-mcard-inner');
    modal.card = $('#upc-mcard');

    $all('[data-upc-close]', modal.el).forEach(function (e) { e.addEventListener('click', closeModal); });
    // clic en dehors de la boîte (zone sombre) -> ferme
    modal.el.addEventListener('mousedown', function (e) { if (e.target === modal.el) closeModal(); });
    var flipBtn = $('#upc-flipBtn'); if (flipBtn) flipBtn.addEventListener('click', function () { setFlip(!modal.flipped); });
    var addBtn = $('#upc-mAdd'); if (addBtn) addBtn.addEventListener('click', addToCart);
    // sélecteur de quantité
    var qInput = $('#upc-mQty'), qMinus = $('[data-mqty-minus]'), qPlus = $('[data-mqty-plus]'), qNote = $('[data-mstock-note]');
    function qClamp(v) { v = parseInt(v, 10); if (isNaN(v) || v < 1) v = 1; return v; }
    function qWarnMax() {
      if (qNote && modal.max) {
        qNote.textContent = 'Il ne reste que ' + modal.max + ' exemplaire' + (modal.max > 1 ? 's' : '') + ' en stock.';
        qNote.classList.add('is-warn');
      }
    }
    // état désactivé des boutons +/- (au min / au max) — comme la page produit
    function updateMqty() {
      if (!qInput) return;
      var v = qClamp(qInput.value);
      if (qMinus) qMinus.classList.toggle('is-disabled', v <= 1);
      if (qPlus) qPlus.classList.toggle('is-disabled', v >= modal.max);
    }
    modal.updateQty = updateMqty;
    if (qMinus) qMinus.addEventListener('click', function () {
      if (!qInput) return;
      if (qMinus.classList.contains('is-disabled')) return;
      qInput.value = Math.max(1, qClamp(qInput.value) - 1);
      updateMqty();
    });
    if (qPlus) qPlus.addEventListener('click', function () {
      if (!qInput || qPlus.classList.contains('is-disabled')) return;
      var v = qClamp(qInput.value) + 1;
      if (v > modal.max) { v = modal.max; qWarnMax(); }
      qInput.value = v;
      updateMqty();
    });
    if (qInput) qInput.addEventListener('input', function () { if (qInput.value !== '') qInput.value = qClamp(qInput.value); updateMqty(); });
    var thF = $('#upc-thF'); if (thF) thF.addEventListener('click', function () { setFlip(false); });
    var thB = $('#upc-thB'); if (thB) thB.addEventListener('click', function () { setFlip(true); });
    var zIn = $('#upc-zIn'); if (zIn) zIn.addEventListener('click', function () { setZoom(modal.zoom + 0.5); });
    var zOut = $('#upc-zOut'); if (zOut) zOut.addEventListener('click', function () { setZoom(modal.zoom - 0.5); });
    var zReset = $('#upc-zReset'); if (zReset) zReset.addEventListener('click', function () { setZoom(1); });

    // tap simple (non zoomé) -> retourne la carte ; on ignore si on vient de
    // glisser (pan) pour ne pas retourner par accident.
    modal.card.addEventListener('click', function () { if (modal.zoom === 1 && !modal._didDrag) setFlip(!modal.flipped); });
    modal.card.addEventListener('wheel', function (e) { e.preventDefault(); setZoom(modal.zoom + (e.deltaY < 0 ? 0.3 : -0.3)); }, { passive: false });
    // tilt au survol UNIQUEMENT quand la carte n'est pas zoomée (le pan zoomé est
    // géré par le glisser ci-dessous).
    modal.card.addEventListener('mousemove', function (e) {
      if (modal.zoom > 1 || modal._dragging) return;
      var r = modal.card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      modal.inner.style.transition = 'transform .1s';
      modal.tiltY = (px - 0.5) * 32; modal.tiltX = (0.5 - py) * 24;
      applyMcard();
    });
    modal.card.addEventListener('mouseleave', function () {
      if (modal.zoom > 1) return;
      modal.tiltX = 0; modal.tiltY = 0;
      modal.inner.style.transition = 'transform .7s cubic-bezier(.3,.9,.3,1)';
      applyMcard();
    });

    // Glisser pour déplacer l'image quand elle est ZOOMÉE (souris ET tactile).
    function panBounds() {
      var r = modal.card.getBoundingClientRect();
      var ex = modal.zoom - 1;
      return { mx: (r.width * ex) / (2 * modal.zoom), my: (r.height * ex) / (2 * modal.zoom) };
    }
    // --- SOURIS (desktop) : glisser pour déplacer quand zoomé ---
    var dsx = 0, dsy = 0, psx = 0, psy = 0;
    modal.card.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // le tactile est géré plus bas
      if (modal.zoom <= 1) return;
      modal._dragging = true; modal._didDrag = false;
      dsx = e.clientX; dsy = e.clientY; psx = modal.panX; psy = modal.panY;
      modal.inner.style.transition = 'none'; modal.card.style.transition = 'none';
      modal.card.classList.add('dragging');
      try { modal.card.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault();
    });
    modal.card.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || !modal._dragging) return;
      var b = panBounds();
      var nx = psx + (e.clientX - dsx), ny = psy + (e.clientY - dsy);
      if (Math.abs(e.clientX - dsx) + Math.abs(e.clientY - dsy) > 4) modal._didDrag = true;
      modal.panX = Math.max(-b.mx, Math.min(b.mx, nx));
      modal.panY = Math.max(-b.my, Math.min(b.my, ny));
      applyMcard();
      e.preventDefault();
    });
    function endDrag(e) {
      if (!modal._dragging) return;
      modal._dragging = false;
      modal.card.style.transition = '';
      modal.card.classList.remove('dragging');
      try { modal.card.releasePointerCapture(e.pointerId); } catch (_) {}
      setTimeout(function () { modal._didDrag = false; }, 0);
    }
    modal.card.addEventListener('pointerup', endDrag);
    modal.card.addEventListener('pointercancel', endDrag);

    // --- TACTILE (mobile) : pincer pour zoomer + glisser pour déplacer ---
    var tMode = null, tDist0 = 0, tZoom0 = 1, tx0 = 0, ty0 = 0, tpx0 = 0, tpy0 = 0;
    function touchDist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    // Safari iOS : empêche le zoom NATIF de la page quand le geste démarre sur la carte
    modal.card.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    modal.card.addEventListener('gesturechange', function (e) { e.preventDefault(); });
    modal.card.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        tMode = 'pinch';
        tDist0 = touchDist(e.touches[0], e.touches[1]);
        tZoom0 = modal.zoom;
        modal.inner.style.transition = 'none'; modal.card.style.transition = 'none';
        modal._didDrag = true;
        e.preventDefault();
      } else if (e.touches.length === 1 && modal.zoom > 1) {
        tMode = 'pan';
        tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY;
        tpx0 = modal.panX; tpy0 = modal.panY;
        modal.inner.style.transition = 'none'; modal.card.style.transition = 'none';
        e.preventDefault();
      } else {
        tMode = null;
      }
    }, { passive: false });
    modal.card.addEventListener('touchmove', function (e) {
      if (tMode === 'pinch' && e.touches.length >= 2) {
        var d = touchDist(e.touches[0], e.touches[1]);
        if (tDist0 > 0) setZoom(tZoom0 * (d / tDist0));
        e.preventDefault();
      } else if (tMode === 'pan' && e.touches.length === 1) {
        var b = panBounds();
        modal.panX = Math.max(-b.mx, Math.min(b.mx, tpx0 + (e.touches[0].clientX - tx0)));
        modal.panY = Math.max(-b.my, Math.min(b.my, tpy0 + (e.touches[0].clientY - ty0)));
        modal._didDrag = true;
        applyMcard();
        e.preventDefault();
      }
    }, { passive: false });
    modal.card.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        tMode = null;
        modal.card.style.transition = '';
        setTimeout(function () { modal._didDrag = false; }, 60);
      } else if (e.touches.length === 1) {
        // fin d'un pinch avec un doigt encore posé -> on bascule en pan si zoomé
        tMode = modal.zoom > 1 ? 'pan' : null;
        tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY;
        tpx0 = modal.panX; tpy0 = modal.panY;
      }
    }, { passive: false });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  // delegated trigger: any element with [data-upc-card]
  function initTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-upc-card]');
      if (!trigger) return;
      // let real add-to-cart / quick-add buttons work normally
      if (e.target.closest('[data-upc-ignore]')) return;
      e.preventDefault();
      openModalFromEl(trigger);
    });
  }

  /* ============================================================
     3. Scroll progress bar + reveals
     ============================================================ */
  function initProgress() {
    var bar = $('#upc-progress');
    if (!bar) return;
    function upd() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  function initReveals(gsap) {
    var els = $all('.upc-reveal');
    // Sur mobile, ScrollTrigger se déclenche mal (grand vide puis "pop" brutal) :
    // on révèle tout immédiatement, comme en reduced-motion. Desktop inchangé.
    var MOBILE = window.matchMedia('(max-width: 989px)').matches;
    if (!gsap || REDUCED || MOBILE) { els.forEach(function (el) { el.style.opacity = 1; el.style.transform = 'none'; }); return; }
    els.forEach(function (el) {
      gsap.to(el, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%' } });
    });
  }

  /* ============================================================
     3b. Menu mobile — on sort le panneau du header vers <body> et on le pilote
         nous-mêmes (le drawer Dawn restait prisonnier du stacking du header :
         liens non cliquables, pas de fermeture fiable). Overlay fixe, premier
         plan, seul scrollable, scroll de page bloqué.
     ============================================================ */
  function initMobileMenu() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    var container = document.querySelector('.menu-drawer-container');
    var panel = document.getElementById('menu-drawer');
    if (!container || !panel || panel.dataset.upcRelocated === '1') return;
    panel.dataset.upcRelocated = '1';

    // sortir le panneau du header -> enfant direct de <body> (échappe au stacking)
    panel.classList.add('upc-menu-panel');
    document.body.appendChild(panel);

    // voile
    var backdrop = document.createElement('div');
    backdrop.className = 'upc-menu-backdrop';
    document.body.appendChild(backdrop);

    // bouton fermer
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'upc-menu-close';
    closeBtn.setAttribute('aria-label', 'Fermer le menu');
    closeBtn.innerHTML = '×';
    panel.insertBefore(closeBtn, panel.firstChild);

    function openMenu() {
      panel.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.classList.add('upc-menu-open');
      panel.setAttribute('aria-hidden', 'false');
    }
    function closeMenu() {
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.classList.remove('upc-menu-open');
      panel.setAttribute('aria-hidden', 'true');
      if (container.hasAttribute('open')) container.removeAttribute('open');
    }
    function toggleMenu() {
      if (panel.classList.contains('is-open')) closeMenu(); else openMenu();
    }

    // Intercepte le tap sur le hamburger AVANT Dawn (capture sur document) :
    // empêche le toggle natif <details> + le handler HeaderDrawer, on pilote tout.
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('summary.header__icon--menu, .menu-drawer-container > summary');
      if (summary && container.contains(summary)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggleMenu();
      }
    }, true);

    backdrop.addEventListener('click', closeMenu);
    closeBtn.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closeMenu();
    });
    // fermer quand on tape un vrai lien (navigation) ; les <summary> de sous-menu
    // ne ferment pas (ils déplient), gérés nativement.
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) closeMenu();
    });
  }

  /* ============================================================
     4. Hero deck fan-out
     ============================================================ */
  function initHeroDeck(gsap) {
    // L'éventail est masqué sur mobile (stage display:none) -> on n'initialise rien.
    if (window.matchMedia('(max-width: 989px)').matches) return;
    var deck = $('#upc-deck');
    if (!deck) return;
    var cards = $all('.upc-card', deck);
    if (!cards.length) return;

    // group cards by row (data-row, default '0') -> fan each row, offset vertically
    var rowMap = {};
    cards.forEach(function (c) { var r = c.getAttribute('data-row') || '0'; (rowMap[r] = rowMap[r] || []).push(c); });
    var rowKeys = Object.keys(rowMap).sort();
    var nRows = rowKeys.length;
    var maxN = 1;
    rowKeys.forEach(function (rk) { maxN = Math.max(maxN, rowMap[rk].length); });

    // éventail FLUIDE : l'écartement s'adapte à la largeur du deck. On ouvre un
    // peu plus (facteur 1.02) pour que les cartes se chevauchent moins.
    var deckRect = cards[0].getBoundingClientRect();
    var deckW = deck.clientWidth || deck.getBoundingClientRect().width || 900;
    var cardW = deckRect.width || 200;
    var cardH = deckRect.height || (cardW * 1.55);
    var SPREAD = maxN > 1 ? Math.max(78, (deckW * 1.02 - cardW) / (maxN - 1)) : 0;
    var scale = SPREAD / 72;
    var ARC = 16 * scale, ARCBASE = 12, ROT = Math.min(7, 5.5 * scale), RY = 4.5, ROWGAP = 236;
    var topKey = rowKeys[0];              // rangée du HAUT (row 0)
    var LIFT = Math.round(cardH * 0.5);   // remontée finale de la rangée du haut

    // precompute fan target + initial stacked transform on each card
    rowKeys.forEach(function (rk, ri) {
      var arr = rowMap[rk], n = arr.length, mid = (n - 1) / 2;
      var baseY = (ri - (nRows - 1) / 2) * ROWGAP;
      arr.forEach(function (c, i) {
        c._tx = (i - mid) * SPREAD;
        c._ty = baseY + Math.abs(i - mid) * ARC - ARCBASE;
        c._rot = (i - mid) * ROT;
        c._ry = (i - mid) * RY;
        c._z = ri * 100 + i;
        c._sy = baseY * 0.26;            // slight row offset while still stacked
        c._srot = (i - mid) * 1.5;
        c._top = (rk === topKey);        // carte de la rangée du haut ?
      });
    });

    if (!gsap || REDUCED) {
      cards.forEach(function (c) {
        c.style.position = 'absolute'; c.style.left = '50%'; c.style.top = '50%';
        var ty = c._ty - (c._top ? LIFT : 0);
        c.style.transform = 'translate(-50%,-50%) translate(' + c._tx + 'px,' + ty + 'px) rotate(' + c._rot + 'deg)';
        c.style.zIndex = c._z;
      });
      return;
    }

    cards.forEach(function (c) {
      gsap.set(c, { xPercent: -50, yPercent: -50, left: '50%', top: '50%', x: 0, y: c._sy, rotate: c._srot, zIndex: c._z });
    });

    var fanVars = {
      x: function (i, t) { return t._tx; },
      y: function (i, t) { return t._ty; },
      rotate: function (i, t) { return t._rot; },
      rotateY: function (i, t) { return t._ry; },
      ease: 'power2.out'
    };

    var topRow = cards.filter(function (c) { return c._top; });
    var liftVars = { y: function (i, t) { return t._ty - LIFT; }, duration: 0.6, ease: 'power2.out' };

    if (DESIGN_MODE) { // éditeur : état final (éventail ouvert + rangée du haut remontée)
      gsap.to(cards, fanVars);
      gsap.to(topRow, Object.assign({ delay: 0.12 }, liftVars));
      return;
    }

    gsap.timeline({
      scrollTrigger: { trigger: '.upc-hero', start: 'top top', end: '+=100%', pin: true, scrub: 0.8, anticipatePin: 1 }
    })
      .to(cards, Object.assign({ duration: 1 }, fanVars), 0)      // 1er temps : l'éventail s'ouvre
      .to('#upc-scroll-cue', { opacity: 0, duration: 0.3 }, 0)
      .to(topRow, liftVars, 1.0);                                 // 2e temps : la rangée du haut remonte
  }

  /* ============================================================
     5. Grail
     ============================================================ */
  function initGrail(gsap) {
    var grail = $('.upc-grail');
    if (!grail) return;
    var inner = $('#upc-grail-inner', grail);
    var rays = $('#upc-rays', grail);
    var tag = $('#upc-flip-tag', grail);
    var priceEl = $('#upc-grail-price', grail);
    var target = priceEl ? parseFloat(priceEl.getAttribute('data-amount') || '0') : 0;
    var suffix = priceEl ? (priceEl.getAttribute('data-suffix') || '') : '';

    // sparks
    var gv = $('.upc-grail-visual', grail);
    if (gv && !gv.dataset.upcSparks) {
      gv.dataset.upcSparks = '1';
      for (var i = 0; i < 20; i++) {
        var s = document.createElement('div');
        s.className = 'upc-spark';
        s.style.left = (18 + Math.random() * 64) + '%';
        s.style.top = (10 + Math.random() * 80) + '%';
        gv.appendChild(s);
        if (gsap && !REDUCED) {
          gsap.to(s, { y: 'random(-50,50)', x: 'random(-50,50)', opacity: 'random(.2,1)', scale: 'random(.4,1.8)', duration: 'random(2,5)', repeat: -1, yoyo: true, ease: 'sine.inOut', delay: Math.random() * 3 });
        }
      }
    }

    function fmt(n) {
      try { return Math.round(n).toLocaleString('fr-FR'); } catch (e) { return String(Math.round(n)); }
    }

    if (!gsap || REDUCED || DESIGN_MODE) {
      if (priceEl) priceEl.textContent = fmt(target) + suffix;
      return;
    }

    gsap.timeline({
      scrollTrigger: {
        trigger: '.upc-grail', start: 'top top', end: '+=120%', pin: true, scrub: 0.8, anticipatePin: 1,
        onUpdate: function (self) {
          if (tag) tag.innerHTML = self.progress > 0.5
            ? '<b>Verso</b> — dos de la carte'
            : '<b>Recto</b> — continuez à défiler pour retourner la carte &#8635;';
        }
      }
    })
      .fromTo(inner, { rotateY: 0 }, { rotateY: 180, ease: 'none' }, 0);
    // les rayons tournent en continu DERRIÈRE la carte (CSS @keyframes upc-rays-spin),
    // on ne les pilote pas au scroll pour éviter qu'ils "sortent" de l'écran.
    void rays;

    if (priceEl) {
      gsap.ScrollTrigger.create({
        trigger: '.upc-grail', start: 'top 70%', once: true,
        onEnter: function () {
          var o = { v: 0 };
          gsap.to(o, { v: target, duration: 1.8, ease: 'power2.out', onUpdate: function () { priceEl.textContent = fmt(o.v) + suffix; } });
        }
      });
    }
  }

  /* ============================================================
     6. Product page gallery (same flip/zoom system as modal)
     ============================================================ */
  function initProductGallery() {
    $all('[data-upc-gallery]').forEach(function (root) {
      if (root.dataset.upcInit) return;
      root.dataset.upcInit = '1';

      var card = root.querySelector('[data-upc-pdp-card]');
      var inner = root.querySelector('[data-upc-pdp-inner]');
      var front = root.querySelector('[data-upc-pdp-front]');
      var back = root.querySelector('[data-upc-pdp-back]');
      if (!card || !inner) return;

      var rectoSrc = front ? front.src : '';
      var versoSrc = back ? back.src : '';
      var hasBack = !!(back && versoSrc && versoSrc !== rectoSrc);

      var st = { flipped: false, zoom: 1, panX: 0, panY: 0, tiltX: 0, tiltY: 0 };
      function apply() {
        card.style.transform = 'translate(' + st.panX + 'px,' + st.panY + 'px) scale(' + st.zoom + ')';
        card.classList.toggle('zoomed', st.zoom > 1);
        inner.style.transform = 'rotateX(' + st.tiltX + 'deg) rotateY(' + ((st.flipped ? 180 : 0) + st.tiltY) + 'deg)';
      }
      function setFlip(v) { if (!hasBack) v = false; st.flipped = v; syncThumbs(); apply(); }
      function setZoom(z) {
        st.zoom = Math.min(3, Math.max(1, z));
        if (st.zoom === 1) {
          st.panX = st.panY = 0;
        } else {
          // re-borne le pan selon le NOUVEAU zoom (sinon la carte "part" au dézoom)
          var b = panBounds(st.zoom);
          st.panX = Math.max(-b.mx, Math.min(b.mx, st.panX));
          st.panY = Math.max(-b.my, Math.min(b.my, st.panY));
        }
        st.tiltX = st.tiltY = 0; apply();
      }

      var thumbs = $all('[data-upc-pdp-thumb]', root);
      function clearActive() { thumbs.forEach(function (t) { t.classList.remove('act'); }); }
      function syncThumbs() {
        if (!thumbs.length) return;
        clearActive();
        var role = st.flipped ? 'verso' : 'recto';
        var match = thumbs.filter(function (t) { return t.dataset.role === role; })[0];
        if (match) match.classList.add('act');
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var role = t.dataset.role;
          var full = t.dataset.full;
          if (role === 'verso' && hasBack) { setFlip(true); }
          else if (role === 'recto') { if (front) front.src = rectoSrc; setFlip(false); }
          else { if (front) front.src = full; setFlip(false); }
          clearActive(); t.classList.add('act');
        });
      });

      // tap simple (non zoomé) -> retourne la carte ; ignoré après un glissement
      card.addEventListener('click', function () { if (st.zoom === 1 && !st._didDrag) setFlip(!st.flipped); });
      card.addEventListener('wheel', function (e) { e.preventDefault(); setZoom(st.zoom + (e.deltaY < 0 ? 0.3 : -0.3)); }, { passive: false });
      // tilt au survol UNIQUEMENT quand la carte n'est pas zoomée (pan = glisser)
      card.addEventListener('mousemove', function (e) {
        if (st.zoom > 1 || st._dragging) return;
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        inner.style.transition = 'transform .1s';
        st.tiltY = (px - 0.5) * 30; st.tiltX = (0.5 - py) * 22;
        apply();
      });
      card.addEventListener('mouseleave', function () {
        if (st.zoom > 1) return;
        st.tiltX = 0; st.tiltY = 0;
        inner.style.transition = 'transform .7s cubic-bezier(.3,.9,.3,1)';
        apply();
      });

      function panBounds(z) {
        // offsetWidth/Height = taille NON scalée -> bornes correctes pour un
        // zoom donné (indépendant de la transformation en cours).
        z = z || st.zoom;
        return { mx: (card.offsetWidth * (z - 1)) / 2, my: (card.offsetHeight * (z - 1)) / 2 };
      }
      // SOURIS (desktop) : glisser pour déplacer quand zoomé
      var dsx = 0, dsy = 0, psx = 0, psy = 0;
      card.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || st.zoom <= 1) return;
        st._dragging = true; st._didDrag = false;
        dsx = e.clientX; dsy = e.clientY; psx = st.panX; psy = st.panY;
        inner.style.transition = 'none'; card.style.transition = 'none';
        card.classList.add('dragging');
        try { card.setPointerCapture(e.pointerId); } catch (_) {}
        e.preventDefault();
      });
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch' || !st._dragging) return;
        var b = panBounds();
        if (Math.abs(e.clientX - dsx) + Math.abs(e.clientY - dsy) > 4) st._didDrag = true;
        st.panX = Math.max(-b.mx, Math.min(b.mx, psx + (e.clientX - dsx)));
        st.panY = Math.max(-b.my, Math.min(b.my, psy + (e.clientY - dsy)));
        apply(); e.preventDefault();
      });
      function endDrag(e) {
        if (!st._dragging) return;
        st._dragging = false; card.style.transition = ''; card.classList.remove('dragging');
        try { card.releasePointerCapture(e.pointerId); } catch (_) {}
        setTimeout(function () { st._didDrag = false; }, 0);
      }
      card.addEventListener('pointerup', endDrag);
      card.addEventListener('pointercancel', endDrag);

      // TACTILE (mobile) : pincer pour zoomer + glisser pour déplacer
      var tMode = null, tDist0 = 0, tZoom0 = 1, tx0 = 0, ty0 = 0, tpx0 = 0, tpy0 = 0;
      function touchDist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
      card.addEventListener('gesturestart', function (e) { e.preventDefault(); });
      card.addEventListener('gesturechange', function (e) { e.preventDefault(); });
      card.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          tMode = 'pinch'; tDist0 = touchDist(e.touches[0], e.touches[1]); tZoom0 = st.zoom;
          inner.style.transition = 'none'; card.style.transition = 'none'; st._didDrag = true;
          e.preventDefault();
        } else if (e.touches.length === 1 && st.zoom > 1) {
          tMode = 'pan'; tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY; tpx0 = st.panX; tpy0 = st.panY;
          inner.style.transition = 'none'; card.style.transition = 'none';
          e.preventDefault();
        } else { tMode = null; }
      }, { passive: false });
      card.addEventListener('touchmove', function (e) {
        if (tMode === 'pinch' && e.touches.length >= 2) {
          var d = touchDist(e.touches[0], e.touches[1]);
          if (tDist0 > 0) setZoom(tZoom0 * (d / tDist0));
          e.preventDefault();
        } else if (tMode === 'pan' && e.touches.length === 1) {
          var b = panBounds();
          st.panX = Math.max(-b.mx, Math.min(b.mx, tpx0 + (e.touches[0].clientX - tx0)));
          st.panY = Math.max(-b.my, Math.min(b.my, tpy0 + (e.touches[0].clientY - ty0)));
          st._didDrag = true; apply(); e.preventDefault();
        }
      }, { passive: false });
      card.addEventListener('touchend', function (e) {
        if (e.touches.length === 0) {
          tMode = null; card.style.transition = '';
          setTimeout(function () { st._didDrag = false; }, 60);
        } else if (e.touches.length === 1) {
          tMode = st.zoom > 1 ? 'pan' : null;
          tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY; tpx0 = st.panX; tpy0 = st.panY;
        }
      }, { passive: false });

      var zin = root.querySelector('[data-upc-pdp-zin]');
      var zout = root.querySelector('[data-upc-pdp-zout]');
      var zreset = root.querySelector('[data-upc-pdp-zreset]');
      if (zin) zin.addEventListener('click', function () { setZoom(st.zoom + 0.5); });
      if (zout) zout.addEventListener('click', function () { setZoom(st.zoom - 0.5); });
      if (zreset) zreset.addEventListener('click', function () { setZoom(1); });
    });
  }

  /* ============================================================
     7. Search overlay (façon maquette) — /search/suggest.json
     ============================================================ */
  function initSearch() {
    var ov = $('#upc-search-ov');
    if (!ov) return;
    var input = $('#upc-search-input');
    var res = $('#upc-search-res');
    var countEl = $('#upc-search-count');
    var goEl = $('#upc-search-go');
    var searchBase = (goEl && goEl.getAttribute('href')) || '/search';
    var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var timer = null;

    function open() {
      if (ov.classList.contains('open')) return;
      ov.classList.add('open'); ov.setAttribute('aria-hidden', 'false');
      lockScroll();
      render('');
      setTimeout(function () { if (input) input.focus(); }, 30);
    }
    function close() {
      if (!ov.classList.contains('open')) return;
      ov.classList.remove('open'); ov.setAttribute('aria-hidden', 'true');
      unlockScroll(); if (input) input.value = '';
    }

    function row(p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      var price = (typeof p.price !== 'undefined') ? p.price : '';
      return '<a class="upc-sres" href="' + (p.url || '#') + '">' +
        '<img src="' + img + '" onerror="this.style.visibility=\'hidden\'">' +
        '<div><div class="st">' + (p.title || '') + '</div>' +
        (price !== '' ? '<div class="sp">' + price + '</div>' : '') + '</div></a>';
    }

    function render(q) {
      q = (q || '').trim();
      if (goEl) {
        goEl.textContent = q ? ('Rechercher « ' + q + ' » →') : '';
        goEl.href = searchBase + '?q=' + encodeURIComponent(q);
      }
      if (!q) {
        if (countEl) countEl.textContent = 'Tapez pour rechercher…';
        res.innerHTML = '';
        return;
      }
      var url = searchBase + '/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (countEl) countEl.innerHTML = '<b>' + items.length + '</b> résultat(s)';
          if (!items.length) { res.innerHTML = '<div class="upc-search-res-lbl lbl">Aucun résultat pour « ' + q + ' »</div>'; return; }
          res.innerHTML = '<div class="lbl">Produits</div>' + items.map(row).join('');
        })
        .catch(function () { res.innerHTML = '<div class="lbl">Recherche indisponible</div>'; });
    }

    $all('[data-upc-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $all('[data-upc-search-close]', ov).forEach(function (b) { b.addEventListener('click', close); });
    if (input) input.addEventListener('input', function (e) {
      clearTimeout(timer); var v = e.target.value; timer = setTimeout(function () { render(v); }, 220);
    });
    var form = $('[data-upc-search-form]', ov);
    if (form) form.addEventListener('submit', function () { /* native submit to /search */ });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------------------
     Rail Live (eBay / Whatnot) — desktop = :hover (CSS) ; tactile = tap
     ------------------------------------------------------------ */
  function initLiveRail() {
    var cards = $all('.upc-live');
    if (!cards.length) return;
    cards.forEach(function (el) {
      var tap = $('[data-upc-live-toggle]', el);
      if (tap) {
        tap.addEventListener('click', function (e) {
          e.preventDefault();
          // une seule carte ouverte à la fois sur tactile
          cards.forEach(function (o) { if (o !== el) o.classList.remove('is-open'); });
          el.classList.toggle('is-open');
        });
      }
    });
    // referme si on touche ailleurs
    document.addEventListener('click', function (e) {
      cards.forEach(function (el) {
        if (el.classList.contains('is-open') && !el.contains(e.target)) {
          el.classList.remove('is-open');
        }
      });
    });
  }

  /* ------------------------------------------------------------
     Badges : célébration "paiement confirmé"
     - détecte une hausse de commandes/€ vs localStorage -> joue l'anim
     - window.upcSimulatePayment(dOrders, dEuros) pour tester/demo
     ------------------------------------------------------------ */
  // Système de POINTS : 1 pt par euro dépensé + 1 pt par commande.
  function _pts(s) { return (s.orders || 0) + (s.spent || 0); }
  function _tierIdx(s, t) { var p = _pts(s), c = 0; for (var i = 0; i < t.length; i++) { if (p >= t[i].p) c = i; } return c; }
  function _pct(s, t, c) {
    if (c >= t.length - 1) return 100;
    var a = t[c], b = t[c + 1], span = b.p - a.p;
    if (span <= 0) return 100;
    return Math.max(0, Math.min(100, (_pts(s) - a.p) / span * 100));
  }
  function _esc(x) { return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function _node(cls, img, name) {
    return '<div class="upc-tl-node ' + cls + '"><span class="upc-tl-badge"><img src="' + img + '" alt="' + _esc(name) + '"></span><span class="upc-tl-lbl">' + _esc(name) + '</span></div>';
  }
  function _tlHTML(s, t) {
    var c = _tierIdx(s, t);
    if (c >= t.length - 1) return _node('is-current', t[c].img, t[c].name);
    return _node('is-current', t[c].img, t[c].name) +
      '<div class="upc-tl-track"><span class="upc-tl-fill" style="width:' + _pct(s, t, c) + '%"></span></div>' +
      _node('is-next', t[c + 1].img, t[c + 1].name);
  }
  function _goalHTML(s, t) {
    var c = _tierIdx(s, t);
    if (c >= t.length - 1) return 'Tu as débloqué <strong>tous les badges de Kanto</strong>. Champion incontesté ! 🏆';
    var n = t[c + 1], rp = Math.max(0, n.p - _pts(s));
    return 'Plus que <strong>' + rp + ' point' + (rp > 1 ? 's' : '') + '</strong> pour débloquer <strong>' + _esc(n.name) + '</strong>.';
  }
  function _setState(acc, s, t) {
    var menu = acc.querySelector('.upc-acc-menu'); if (!menu) return;
    var c = _tierIdx(s, t);
    var tl = menu.querySelector('.upc-tl'); if (tl) { tl.innerHTML = _tlHTML(s, t); tl.className = 'upc-tl' + (c >= t.length - 1 ? ' upc-tl--max' : ''); }
    var goal = menu.querySelector('.upc-acc-goal'); if (goal) goal.innerHTML = _goalHTML(s, t);
    var tier = menu.querySelector('.upc-acc-tier'); if (tier) tier.textContent = t[c].name;
    var ava = acc.querySelector('.upc-ava img'); if (ava) ava.src = t[c].img;
  }
  function _toast(dO, dE) {
    var el = document.createElement('div'); el.className = 'upc-pay-toast';
    var bits = []; if (dO) bits.push('+' + dO + ' commande' + (dO > 1 ? 's' : '')); if (dE) bits.push('+' + dE + ' €');
    el.innerHTML = '<span class="tick">✓</span> Paiement confirmé <small>' + bits.join(' · ') + '</small>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('show'); });
    setTimeout(function () { el.classList.remove('show'); setTimeout(function () { el.remove(); }, 360); }, 4200);
  }
  function _confetti(node) {
    var wrap = document.createElement('span'); wrap.className = 'upc-confetti';
    var cols = ['#ffd21e', '#37d67a', '#3f7dff', '#ff5b5b', '#ffffff'];
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('i');
      var ang = Math.random() * Math.PI * 2, dist = 28 + Math.random() * 46;
      s.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(0) + 'px');
      s.style.setProperty('--dy', (Math.sin(ang) * dist).toFixed(0) + 'px');
      s.style.background = cols[i % cols.length];
      s.style.animationDelay = (Math.random() * 0.12).toFixed(2) + 's';
      wrap.appendChild(s);
    }
    node.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 1100);
  }
  function _closeLater(acc) {
    clearTimeout(acc._upcT);
    acc._upcT = setTimeout(function () { if (!acc.matches(':hover')) acc.classList.remove('is-open'); }, 5200);
  }
  function _celebrate(acc, from, to, t) {
    var menu = acc.querySelector('.upc-acc-menu'); if (!menu) return;
    var oc = _tierIdx(from, t), nc = _tierIdx(to, t);
    _setState(acc, from, t);              // repart de l'ancien état
    acc.classList.add('is-open');
    _toast(to.orders - from.orders, to.spent - from.spent);
    void menu.offsetWidth;                 // reflow -> la barre partira de l'ancienne largeur
    setTimeout(function () {
      var fill = menu.querySelector('.upc-tl-fill');
      if (nc === oc) {                     // même palier : on avance la barre
        if (fill) fill.style.width = _pct(to, t, nc) + '%';
        var goal = menu.querySelector('.upc-acc-goal'); if (goal) goal.innerHTML = _goalHTML(to, t);
        _closeLater(acc);
      } else {                             // palier suivant : on remplit puis on unlock
        if (fill) fill.style.width = '100%';
        setTimeout(function () { _unlock(acc, to, t); }, 750);
      }
    }, 560);
  }
  function _unlock(acc, to, t) {
    var menu = acc.querySelector('.upc-acc-menu');
    var nextNode = menu.querySelector('.upc-tl-node.is-next');
    if (nextNode) { nextNode.classList.add('is-unlocking'); _confetti(nextNode); }
    var ava = acc.querySelector('.upc-ava');
    setTimeout(function () {
      if (ava) { ava.classList.add('pop'); setTimeout(function () { ava.classList.remove('pop'); }, 650); }
      _setState(acc, to, t);             // nouveau badge courant + prochain badge suivant
      var fill = menu.querySelector('.upc-tl-fill');
      if (fill) { var w = fill.style.width; fill.style.width = '0%'; void menu.offsetWidth; fill.style.width = w; }
      _closeLater(acc);
    }, 1150);
  }
  function initBadgeProgress() {
    var dataEl = $('#upc-badge-data');
    var acc = $('.upc-acc');
    if (!dataEl || !acc) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var tiers = data.tiers, server = { orders: data.orders, spent: data.spent };
    var key = 'upc_badge_seen_' + (data.id || 'x');   // cloisonné par client

    // test/demo : déclenche la séquence à la main
    window.upcSimulatePayment = function (dOrders, dEuros) {
      var a = document.querySelector('.upc-acc'); if (!a) return;
      var from = { orders: server.orders, spent: server.spent };
      var to = { orders: from.orders + (dOrders == null ? 1 : dOrders), spent: from.spent + (dEuros || 0) };
      server = to;
      _celebrate(a, from, to, tiers);
      try { localStorage.setItem(key, JSON.stringify(server)); } catch (e) {}
    };

    // détection réelle : a-t-on commandé depuis la dernière visite ?
    try {
      var seen = JSON.parse(localStorage.getItem(key) || 'null');
      if (seen && (server.orders > seen.orders || server.spent > seen.spent)) {
        _celebrate(acc, seen, server, tiers);
      }
      localStorage.setItem(key, JSON.stringify(server));
    } catch (e) {}
  }

  /* ------------------------------------------------------------
     Header : un seul dropdown ouvert à la fois (pas de superposition)
     ------------------------------------------------------------ */
  function initHeaderMenus() {
    var nav = $('.header__inline-menu');
    if (!nav) return;
    var allDetails = $all('details', nav);
    if (!allDetails.length) return;
    allDetails.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        // ferme tout <details> ouvert qui n'est ni ancêtre ni descendant de `d`
        allDetails.forEach(function (o) {
          if (o === d) return;
          if (!o.open) return;
          if (o.contains(d) || d.contains(o)) return;
          o.removeAttribute('open');
        });
      });
    });
    // clic en dehors de la nav -> on referme tout
    document.addEventListener('click', function (e) {
      if (e.target.closest('.header__inline-menu')) return;
      allDetails.forEach(function (d) { if (d.open) d.removeAttribute('open'); });
    });
  }

  /* ------------------------------------------------------------
     Re-init des cartes ajoutées dynamiquement (reco "Attrapez les tous",
     facettes AJAX…) -> tilt + holo + reveal partout.
     ------------------------------------------------------------ */
  function observeCards(gsap) {
    if (!('MutationObserver' in window)) return;
    var pending = false;
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.classList && n.classList.contains('upc-card') || (n.querySelector && n.querySelector('.upc-card')))) {
            if (!pending) {
              pending = true;
              requestAnimationFrame(function () {
                pending = false;
                initCardHover();
                initReveals(gsap);
              });
            }
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* ============================================================
     Boot
     ============================================================ */
  ready(function () {
    var gsap = window.gsap;
    if (gsap && window.ScrollTrigger) {
      gsap.registerPlugin(window.ScrollTrigger);
      gsap.ScrollTrigger = window.ScrollTrigger;
    } else {
      gsap = null;
    }

    initCardHover();
    initModal();
    initPdpQty();
    initStockSync();
    initTriggers();
    initProgress();
    initProductGallery();
    initSearch();
    initLiveRail();
    initBadgeProgress();
    initHeaderMenus();
    initMobileMenu();
    initHeroDeck(gsap);
    initGrail(gsap);
    initReveals(gsap);
    observeCards(gsap);

    document.addEventListener('upc:recommendations:loaded', function () {
      initCardHover();
      initReveals(gsap);
    });

    // re-init cards when sections re-render in the theme editor
    if (DESIGN_MODE) {
      document.addEventListener('shopify:section:load', function () {
        initCardHover();
        initProductGallery();
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      });
    }
  });
})();
